import * as React from "react";

export const IconArrowUp = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="1em" height="1em" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_24958_43636)">
      <path d="M6.175 13.343L10 9.5263L13.825 13.343L15 12.168L10 7.16797L5 12.168L6.175 13.343Z" fill="currentColor" />
    </g>
    <defs>
      <clipPath id="clip0_24958_43636">
        <rect width="20" height="20" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);
